import { FC, SVGProps } from "react";
import { useMirrorTransform } from "src/i18n/direction";

type AirPlaneIconProps = SVGProps<SVGSVGElement> & { mirrorInRtl?: boolean };

const AirPlaneIcon: FC<AirPlaneIconProps> = ({ transform, mirrorInRtl, ...props }) => {
  const mirroredTransform = useMirrorTransform(transform as string | undefined);
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      stroke="currentcolor"
      strokeLinejoin="round"
      transform={mirrorInRtl ? mirroredTransform : transform}
      {...props}
    >
      <path d="M19.9397 12.4087C21.1996 12.4096 22.4796 12.4106 24.0925 12.4117C25.1574 12.4038 27.9999 13.2781 27.9999 14.3336C28.0199 15.4088 25.1695 16.2516 24.1045 16.2437H18.9821L18.4396 16.2556L11.4662 27.7325C11.1633 28.2311 10.4746 28.3168 10.0587 27.9076C9.82065 27.6735 9.73096 27.3272 9.82541 27.0069L11.5817 21.0507C11.7516 20.4747 11.8376 19.8772 11.8369 19.2766L11.8339 16.2556L11.3947 16.2437H6.99322C6.61134 16.2437 6.25042 16.4183 6.01333 16.7177L3.72382 19.6084C3.48424 19.9109 3.07764 20.0255 2.71532 19.8928C2.28471 19.735 2.04328 19.277 2.15644 18.8326L2.90763 15.8825C2.94922 15.7192 2.85436 15.5521 2.69276 15.5041C1.46552 15.1876 0.498377 14.7839 0.500002 14.3218C0.501586 13.8716 1.42024 13.4768 2.60206 13.1641C3.122 13.0265 2.88058 12.58 2.74787 12.0588L2.15596 9.73425C2.04309 9.29095 2.2839 8.83414 2.71342 8.67677C3.07649 8.54375 3.48393 8.65985 3.72235 8.96428L6.03776 11.9206C6.2747 12.2232 6.6376 12.3999 7.02186 12.3999L10.6131 12.4021L11.8619 12.4158V9.38757C11.8619 8.78915 11.776 8.19384 11.6067 7.61985L9.84945 1.66055C9.75501 1.34026 9.84469 0.993985 10.0827 0.759807C10.4986 0.350687 11.1873 0.436386 11.4902 0.934954L18.4636 12.4118H19.9397" />
    </svg>
  );
};

export default AirPlaneIcon;
